import { like, type SQL, sql } from 'drizzle-orm';
import { tasks } from '../powersync/schemas/tasks.schema';

/** The assignee filter value for tasks nobody is assigned to. */
export const UNASSIGNED_TASKS = 'unassigned';

/**
 * The tasks assigned to `assignee`, a user id as text, or nobody's (`UNASSIGNED_TASKS`).
 *
 * Matches `"<id>"` inside the column, which is how the backend filters it (`TaskService`): both the
 * `["12"]` this app writes and the legacy `"12","34"` hold the id in quotes, and the quotes keep
 * `1` from matching `12`. Unassigned covers every way a row can say nobody: `NULL`, `''` and `[]`.
 */
export const taskAssigneeWhere = (assignee: string): SQL | undefined => {
  if (assignee === UNASSIGNED_TASKS) {
    return sql`COALESCE(${tasks.assignee_ids}, '') IN ('', '[]')`;
  }

  // Only a user id can be named: anything else would put LIKE wildcards in the pattern.
  return /^\d+$/.test(assignee) ? like(tasks.assignee_ids, `%"${assignee}"%`) : undefined;
};
